import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageHI() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: AI संबंध विश्लेषण | जहरीले पैटर्न और गैसलाइटिंग का पता लगाएं" description="पता करें कि क्या आपका पूर्व-साथी समस्या है। हेरफेर, गैसलाइटिंग और लाल झंडों के तत्काल, गोपनीय विश्लेषण के लिए अपनी चैट को ToxicDetector के AI पर अपलोड करें। आज ही मुफ्त स्कैन शुरू करें।" keywords="AI संबंध विश्लेषण, जहरीले पैटर्न का पता लगाएं, गैसलाइटिंग डिटेक्टर, जहरीला पूर्व, हेरफेर चेकर, संबंध विषाक्तता, AI टेक्स्ट स्कैनर" canonical="https://toxicdetector.com/hi" language="hi" alternateUrls={alternateUrls} data-id="element-6651" />
      <GoogleTranslateWidget data-id="element-6652" />
      <PromoBanner data-id="element-6653" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-6654">
        <Header data-id="element-6655" />
        <main data-id="element-6656">
          <HeroSection h1Override={<>
                आपका दिमाग आपसे{' '}
                <span className="relative inline-block" data-id="element-6658">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-6659">
                    झूठ
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-6660" />
                </span>{' '}
                बोल रहा है।
                <br data-id="element-6661" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-6662">
                  हमारा AI नहीं।
                </span>
              </>} data-id="element-6657" />
          <TrustSection data-id="element-6663" />
          <FeaturesSection data-id="element-6664" />
          <GuaranteesSection data-id="element-6665" />
          <ToolsSection data-id="element-6666" />
          <ComparisonSection data-id="element-6667" />
          <PricingSection data-id="element-6668" />
          <FAQSection data-id="element-6669" />
          <CTASection data-id="element-6670" />
        </main>
        <Footer data-id="element-6671" />
      </div>
    </>;
}